import Controller, { OnAfterFetch, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ActionAPI, ToastNotificationAPI } from '@philips-internal/oswald-ui-components';
import { ClickEvent, FetchEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';

import BaseController from '../BaseController';
import TASK_STATUS from '../../constants/task-status';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { TasksUtils } from '../../utils/tasks-utils';
import { ConsentFormAliases, FragmentNames } from '../../codegen';
import { DYNAMIC_STEP_IDENTIFIER } from './tasks-controller';

import './consent-form-controller.css';
import TaskItem from '../../interfaces/task-item';

interface ConsentForm {
  dsTarefa: string;
  dsTitulo: string;
  ieStatusTarefa: string;
  nrSeqAgenda: number;
}

@Controller({ component: ConsentFormAliases.CONSENT_FORM_LAYOUT, fragment: FragmentNames.CONSENT_FORM })
class ConsentFormController extends BaseController {

  disableCheckAction = true;

  @Inject(ConsentFormAliases.CONSENT_FORM_CHECK_ACTION)
    ConsentFormCheckActionApi!: ActionAPI;

  @Inject(ConsentFormAliases.TOAST_NOTIFICATION)
    toastNotificationBlockMessageApi!: ToastNotificationAPI;

  @OnMount(ConsentFormAliases.CONSENT_FORM_CHECK_ACTION)
  onMountAction(event: MountEvent): void {
    const actionApi = event.target as ActionAPI;
    const identifier = this.context.get<string>('identifier');
    const nrSequencia = identifier.split(DYNAMIC_STEP_IDENTIFIER.CONSENT_FORM.concat('-'))[1];
    this.context.set({ nrSequencia });

    this.setInitialActionStatus(actionApi, nrSequencia);
  }

  private setInitialActionStatus(checkActionAPI: ActionAPI, taskSequence: string): void {
    const taskList = this.context.get('taskList') as TaskItem[];
    const materialInstitutionalTask = taskList.find(task => task.nrSequencia === Number(taskSequence));

    if (materialInstitutionalTask) {
      TasksUtils.setInitialActionStatus({
        checkActionAPI,
        onBlocked: () => this.toastNotificationBlockMessageApi.setVisible(true),
        taskItem: materialInstitutionalTask,
      });
    }
  }

  @OnAfterFetch(ConsentFormAliases.CONSENT_FORM_FETCH)
  onAfterFetch(event: FetchEvent): void {
    const consentFormDataList = event.data as ConsentForm[];

    if (!consentFormDataList || consentFormDataList.length === 0) return;

    const consentFormData = consentFormDataList[0];
    if (consentFormData?.ieStatusTarefa === TASK_STATUS.PENDING) {
      this.disableCheckAction = false;
    } else {
      const identifier = this.context.get('identifier') as string;

      TasksUtils.setActionChecked(this.ConsentFormCheckActionApi, identifier)
      this.disableCheckAction = true;
    }
  }

  @OnClick(ConsentFormAliases.CONSENT_FORM_CHECK_ACTION)
  onClickCheckAction(event: ClickEvent): void {
    if (this.disableCheckAction) return;

    const checkAction = event.target as ActionAPI;
    const nrSequencia = this.context.get('nrSequencia');
    const identifier = this.context.get('identifier') as string;

    HttpService.put(APPLICATION_ENDPOINTS.UPDATE_TASK_STATUS, { nrSequencia, taskType: 'TC' }).then(() => {
      TasksUtils.setActionChecked(checkAction, identifier);
      this.disableCheckAction = true;
    });
  }
}

export default ConsentFormController;
